import { render, staticRenderFns } from "./LabInfoEdit.vue?vue&type=template&id=3f38c7f0&scoped=true&"
import script from "./LabInfoEdit.vue?vue&type=script&lang=js&"
export * from "./LabInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./LabInfoEdit.vue?vue&type=style&index=0&id=3f38c7f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38c7f0",
  null
  
)

export default component.exports